<template>
  <div class="relative hidden bg-slate-50 lg:block">
    <div class="mx-auto max-w-3xl px-8 py-8 lg:max-w-6xl lg:py-12">
      <div class="relative">
        <div class="text-center">
          <h3
            class="relative text-2xl font-semibold leading-tight tracking-tight text-[#20484F] md:text-4xl lg:text-[2.7em] lg:leading-tight"
          >
            How Veridis Works
          </h3>
          <div class="mx-auto mb-8 max-w-lg md:mb-10 lg:mb-14 lg:max-w-lg">
            <p class="mt-6 text-base text-gray-500 md:text-base lg:text-base">
              Use our intuitive calculator to find out how much CO2 you emit and
              maximize the efficacy of your sustainability strategies.
            </p>
          </div>
        </div>

        <div class="mt-10 w-full lg:mt-0">
          <div class="grid grid-cols-2 gap-4">
            <div class="lg:pb-16">
              <div class="flex">
                <svg
                  width="15"
                  height="15"
                  class="mr-2 mt-1.5"
                  viewBox="0 0 30 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H9.83607L30 20L9.83607 40H0V0Z"
                    fill="#037957"
                  />
                </svg>
                <span
                  class="counter mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
                >End-to-End Carbon Accounting</span>
              </div>
              <span
                class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
              >Automatically pull data from across your enterprise systems and
                calculate their environmental impact.</span>
            </div>
            <div class="lg:pb-16">
              <div class="flex">
                <svg
                  width="15"
                  height="15"
                  class="mr-2 mt-1.5"
                  viewBox="0 0 30 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H9.83607L30 20L9.83607 40H0V0Z"
                    fill="#037957"
                  />
                </svg>
                <span
                  class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
                >Lifecycle Tracking and Analysis</span>
              </div>
              <span
                class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
              >Understand the carbon footprint of every step in the supply
                chain to make targeted improvements to your operations.</span>
            </div>
            <div>
              <div class="flex">
                <svg
                  width="15"
                  height="15"
                  class="mr-2 mt-1.5"
                  viewBox="0 0 30 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H9.83607L30 20L9.83607 40H0V0Z"
                    fill="#037957"
                  />
                </svg>
                <span
                  class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
                >Comprehensive Reporting</span>
              </div>
              <span
                class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
              >Instantly build reports compliant with universal frameworks
                like the GHG Protocol, TCFD, SASB, FRI, CDP and more.</span>
            </div>
            <div>
              <div class="flex">
                <svg
                  width="15"
                  height="15"
                  class="mr-2 mt-1.5"
                  viewBox="0 0 30 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H9.83607L30 20L9.83607 40H0V0Z"
                    fill="#037957"
                  />
                </svg>
                <span
                  class="mb-2 block text-2xl font-semibold leading-tight tracking-tight text-[#20484F] lg:text-[1.3em] lg:leading-tight"
                >Reduction and Offset Recommendations</span>
              </div>
              <span
                class="lg:text-md md:text-md block text-base font-normal leading-tight text-gray-500 lg:leading-tight"
              >Use data-driven insights to choose the most effective and
                cost-efficient ways to make positive impacts on the
                climate.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowSection',
}
</script>

<style>
.inset-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
